const PATH = "/api/v1/whatsapp";

const ENDPOINTS = {
  WHATSAPP_SEND_MESSAGE_CONTEXT: "/send/message/context/",
};

export type WhatsAppEndpoints = keyof typeof ENDPOINTS;
export const WhatsAppCollection = { PATH, ENDPOINTS };
